import React, {useEffect} from "react";

import {CheckOutlined, DeleteOutlined, OrderedListOutlined, QuestionOutlined} from "@ant-design/icons";
import {Button, Descriptions, Popconfirm, Row, Tooltip} from "antd";

import {getStatusTag} from "./BucketApproveViewer";
import {createWorkflowLink} from "../../helpers";
import {DataCard} from "../helpers/cards/Card";
import {Link} from "../helpers/cards/MaterialBlock";
import {ModalWindow} from "../helpers/modals/ModalWindow";
import {StandardTable} from "../helpers/TablePanel";

export function BucketsList({buckets, onAddBucket, onDelete, openBucket, onApprovalStart}) {
	const [showModal, setShowModal] = React.useState(false);
	const [selectedBucket, setSelectedBucket] = React.useState({});

	useEffect(() => {
		if (!showModal) {
			setSelectedBucket(null);
		}
	}, [showModal]);

	const getColumns = () => [
		{
			dataIndex: "name",
			title: "Name",
		},
		{
			dataIndex: "description",
			title: "Description",
		},
		{
			dataIndex: "statistics",
			title: "Statistics",
		},
		{
			dataIndex: "material_count",
			title: "Materials",
			width: 100,
		},
		{
			dataIndex: "status",
			title: "Status",
			render: status => getStatusTag(status),
			width: 100,
		},
		{
			dataIndex: "actions",
			title: "Actions",
			width: 225,
			render: (actions, item) => (
				<Row>
					<Button
						style={{margin: "0 5px"}}
						primary
						onClick={() => {
							setShowModal(true);
							setSelectedBucket(item);
						}}
						icon={
							<Tooltip title={`Show additional information`}>
								<QuestionOutlined />
							</Tooltip>
						}
					/>
					<Button
						style={{margin: "0 5px"}}
						primary
						icon={
							<Tooltip title={`Open Bucket ${item.name}`}>
								<OrderedListOutlined onClick={() => openBucket(item._id)} />
							</Tooltip>
						}
					/>
					{(item.status === "rejected" || item.status === "pending") && (
						<div>
							<Popconfirm
								title="Are you sure you want to approve this bucket?"
								onConfirm={() => onApprovalStart(item._id)}
								okText="Yes, Start approve"
								cancelText="No">
								<Button
									style={{margin: "0 5px"}}
									primary
									icon={
										<Tooltip title={`Approve Bucket ${item.name} ?`}>
											<CheckOutlined />
										</Tooltip>
									}
								/>
							</Popconfirm>
						</div>
					)}
					{(item.status === "rejected" || item.status === "pending") && (
						<div>
							<Popconfirm
								title="Are you sure you want to delete this bucket?"
								onConfirm={() => onDelete(item._id)}
								okText="Yes, Delete"
								cancelText="No">
								<Button
									danger
									style={{margin: "0 5px"}}
									icon={
										<Tooltip title={`Delete Bucket ${item.name} ?`}>
											<DeleteOutlined />
										</Tooltip>
									}
								/>
							</Popconfirm>
						</div>
					)}
				</Row>
			),
		},
	];

	return (
		<DataCard
			title={
				<div style={{float: "right"}}>
					<Button onClick={onAddBucket}>+</Button>
				</div>
			}>
			<StandardTable size={"small"} columns={getColumns()} data={buckets.items} total={buckets.total} />
			<ModalWindow
				isModalVisible={showModal}
				title="Bucket Information"
				onOk={() => setShowModal(false)}
				onCancel={() => setShowModal(false)}>
				<Descriptions bordered>
					<Descriptions.Item span={3} labelStyle={{fontWeight: "bold"}} label={"Created By"}>
						{selectedBucket?.created_by}
					</Descriptions.Item>
					<Descriptions.Item span={3} labelStyle={{fontWeight: "bold"}} label={"Created At"}>
						{new Date(selectedBucket?.created_at) &&
							new Date(selectedBucket?.created_at).toLocaleDateString("en-US", {
								year: "numeric",
								month: "short",
								day: "numeric",
							})}
					</Descriptions.Item>
					<Descriptions.Item span={3} labelStyle={{fontWeight: "bold"}} label={"Attached Workflow"}>
						<Link href={createWorkflowLink(selectedBucket?.project_id, selectedBucket?.workflow_id)}>
							{selectedBucket?.workflow_info?.name}
						</Link>
					</Descriptions.Item>
				</Descriptions>
			</ModalWindow>
		</DataCard>
	);
}
